import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PayerSelect from '../../payer-select/';
import dataLoad from '../../../actions/data-load';


function mapStateToProps(state) {
  console.log('state in container', state);
  return {
    payers: state.customer && state.customer.business && state.customer.business.payers,
    customer: state.customer,
    user: state.user,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PayerSelect);
